<script setup>
import { useRoute } from 'vue-router';
import {
  LAIS_SETTINGS_WRAPPER_CLASS,
  LAIS_SETTINGS_WRAPPER_INNER_CLASS,
} from 'dashboard/helper/laisClassNames';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();
</script>

<template>
  <div :class="LAIS_SETTINGS_WRAPPER_CLASS">
    <div :class="LAIS_SETTINGS_WRAPPER_INNER_CLASS">
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
